import { Container, Heading } from '@hover/blueprint';
import React from 'react';

const HoverSaveTime: React.FC = () => (
  <Container
    maxW="980px"
    center
    px={{ base: 500, desktop: 0 }}
    mb={{ base: '72px', desktop: 1100 }}
  >
    <Heading
      size={{ base: 500, tablet: 600, desktop: 700 }}
      textAlign="center"
      fontWeight={{ base: 600, desktop: 600 }}
      style={{ marginBottom: 24 }}
    >
      HOVER not only makes home restoration projects simpler, but a lot less
      stressful
    </Heading>
    <Heading
      size={{ base: 300, desktop: 500 }}
      textAlign="center"
      fontWeight={{ base: 400, desktop: 400 }}
      marginBottom={{ base: 0, desktop: 0 }}
    >
      We help you respond to claims faster. Remote damage surveys, accurate
      measurements, and seamless integration to your existing tools make it
      easier to support your customers as they get their homes back to feeling
      like homes again.
    </Heading>
  </Container>
);

export default HoverSaveTime;
